export const footerLinks = [{
    name: "Contact",
    url: "https://growthscape.com/contact"
},
{
    name: "Privacy Policy",
    url: "https://growthscape.com/privacy-policy"
},
{
    name: "Growthscape LLC",
    url: "https://growthscape.com/"
}]